module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7r8n5n1r-0a74204692f48e04412690bef1e8f405.svg";